// @ts-nocheck
// Demo data and storage helpers for Business Assistant frontend.
//import { startOfWeek, endOfWeek, eachDayOfInterval, format, startOfMonth, endOfMonth } from "https://esm.sh/date-fns";
export class Storage {
  constructor(path: string, params: string) {
    this._data = DefaultData(path, params);
  }
  read(path: string, params: string) {
    return DefaultData(path, params);
  }
  widgets(id: string, slug: string, path: string) {
    //console.log(id, slug);
    if (id && slug) {
      //console.log('cosa esce: ', search({id:id, relate: [slug] }));
      return { item: search({ id: id, relate: [slug] }), default: DefaultData(path) }; // togliere get
    } else {
      return { default: DefaultData(path) };
    }
  }
  get(slug: string, obj: string, path: string) {
    //console.log('slug', slug, 'obj', obj, 'path', path);
    if (slug && obj) {
      return { item: search({ type: slug, orderby: obj, relate: true }), default: DefaultData(path) };
    } else if (slug) {
      return { item: search({ type: slug }), default: DefaultData(path) };
    } else {
      return { default: DefaultData(path) };
    }
  }
  calendar(body: any) {
    return [
      ...search({ type: 'tsk', start: body.start, end: body.end }),
      ...search({ type: 'evn', start: body.start, end: body.end })
    ];
  }
  item(id: string, path: string) {
    //console.log('item data_handling id', id, 'path', path);
    return itemCreator(id, path);
  }
}

const now = new Date();
now.toISOString().split('.')[0];

//function formattedDate(date) {
//  const isoString = date.toISOString();
//  return isoString.split('.')[0];
//}

const now_hour = now
  .toLocaleTimeString('it-IT', {
    hour: '2-digit',
    hour12: false
  })
  .padStart(2, '0')
  .split(':')[0];
const now_minute = now
  .toLocaleTimeString('it-IT', {
    minute: '2-digit',
    hour12: false
  })
  .padStart(2, '0')
  .split(':')[0];
const now_date = now.toLocaleDateString('it-IT');

function DefaultData(path, params) {
  return {
    search: search,
		buildTree: buildTree,
    get: get,
    translate: translate,
    now_hour: now_hour,
    now_minute: now_minute,
    now_date: now_date,
    dateFormatter: dateFormatter,
    lang: 'en',
    path: path,
		params: params,
    current_user: search({ id: 'prf-1', relate: ['avatar'] }),
    notifications: {
      alerts: [
        { id: 'alert-1', label: 'Reminder', description: 'Team sync at 15:00' },
        { id: 'alert-2', label: 'Prompt', description: 'Finish invoice draft' }
      ],
      mentions: [
        { id: 'mention-1', label: '@Marco', description: 'You were mentioned in task tsk-4' }
      ],
      platform: [
        { id: 'platform-1', label: 'Update', description: 'New feature available' }
      ]
    },
    defaultAvatar: {
      id: 'default',
      format: 'image/png',
      link: 'https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png'
    },
    notAssigned: {
      id: 'not-assigned',
      full_name: 'Not Assigned',
      avatar: [
        {
          id: 'default',
          format: 'image/jpg',
          link: 'https://img.freepik.com/premium-vector/question-mark-person-head-icon-as-unknown-secret-anonym-user-profile-doubt-secret-brain-mind_101884-2200.jpg'
        }
      ]
    }
  };
}

function itemCreator(id, path) {
	const content = search({ id: id, relate: true });
	const header = {
    slug: content.slug || null,
    title: content.title || null		
	}
  return {
		default: DefaultData(path), 
		head: header, 
		content: content,
  };
}
//console.log('itemCreator', itemCreator('cll-3'));

function dateFormatter(input) {
  const date = input instanceof Date ? input : new Date(input);
  const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const dayOfWeek = days[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${dayOfWeek} ${day} ${month} at ${hours}:${minutes}`;
}

function translate(key) {
  let currentLanguage = 'en';
  const translationsObj = translations();
  const langCurrent = translationsObj[currentLanguage];
  const langFallback = translationsObj['en'];

  if (langCurrent && langCurrent[key]) {
    return langCurrent[key];
  } else if (langFallback && langFallback[key]) {
    console.log(
      `Manca la traduzione in ${currentLanguage} per la chiave: ${key}, utilizzata la traduzione in inglese.`
    );
    return langFallback[key];
  } else {
    //console.log(`${key}: "",`);
    return key;
  }
}

function get(w) {
  // TODO ALL RETRIVE DYNAMIC DATA
  const actions = {
    unread_messages: () => {
      //return buildTree(search({ type: 'mss', relate: ['prf', 'avatar'] }));
    },
    todays_tasks: () => {
      const today = new Date().toISOString().slice(0, 10);
      const tasks = search({ type: 'tsk', relate: ['prf', 'prj', 'lst', 'avatar'] }) || [];
      return tasks.filter(item => {
        const dateField = item.end || item.dueDate || item.start;
        return typeof dateField === 'string' && dateField.startsWith(today);
      });
    },
    list: () => {
      return buildTree(search({ type: 'prj', relate: ['avatar'] }));
    },
    projects: () => {
      return database();
      //return search({ type: "projects", relate: ["prf", "avatar"]});
    },
    whats_new: () => {
      //return search({ type: 'tml', relate: true });
      return {
        tml: buildTree(search({ type: 'tml', relate: true })),
        tsk: buildTree(search({ type: 'tsk', relate: ['prf', 'prj', 'cmp', 'lst', 'avatar'] }))
      };
    },
    events: () => {
      return search({ type: 'events', relate: ['prf', 'avatar'] });
    },
    chats: () => {
      return search({ type: 'chats', relate: ['prf', 'avatar'] });
    },
    logo: () => {
      const data = {};
      data['logo'] = search({ type: '["stt", "style", "logo"]', relate: true, get: 'link' });
      data['logo_mini'] = search({ type: '["stt", "style", "logo_mini"]', relate: true, get: 'link' });
      return data;
    },
    current_user: () => {
      return search({ id: 'prf-1' });
    }
  };

  if (actions[w]) {
    return actions[w]();
  } else {
    console.log('Please, specify a valid "case" for: ' + w);
    return null;
  }
}

function buildTree(lines) {
  const map = {};
  const roots = [];

  if (!lines || !Array.isArray(lines) || lines.length === 0) {
    return [];
  }

  lines.forEach(item => {
    map[item.id] = { ...item, tsk: [] };
  });

  lines.forEach(item => {
    if (item.tsk && item.tsk.length) {
      item.tsk.forEach(childId => {
        if (map[childId]) {
          map[item.id].tsk.push(map[childId]);
        }
      });
    }
  });

  const childrenIds = new Set();
  lines.forEach(item => {
    if (item.tsk && item.tsk.length) {
      item.tsk.forEach(id => childrenIds.add(id));
    }
  });

  lines.forEach(item => {
    if (!childrenIds.has(item.id)) {
      roots.push(map[item.id]);
    }
  });

  return roots;
}

export function search(query) {
  const { type, id, slug, tp, orderby = '', sort = '', relate, get, start, end } = query;
  let db = database();
  let result = [];

  //console.error('search(query)', query);

  // Step 1: Search by ID
  if (id) {
    if (typeof id === 'string') {
      const [type, idValue] = id.split('-');
      if (db[type]) {
        result = db[type].find(item => item.id === id);
        result = result ? enrichItem(result, relate) : null;
      }
    } else {
      console.error('ID format error: ID should be a string');
      return null;
    }
  }

  // Step 1b: Search by SLUG
  else if (slug && tp && db[tp]) {
    result = db[tp].filter(item => item.slug === slug);
  }

  // Step 2: Search by Type
  else if (type && db[type]) {
    result = db[type];
  }

  // Step 3: Search by Root (percorso annidato)
  else if (type && Array.isArray(JSON.parse(type))) {
    let path = JSON.parse(type);
    result = db;
    for (let key of path) {
      if (result[key]) {
        result = result[key];
      } else {
        console.log('Step 3 path error: ', path);
        return [];
      }
    }
  }

  // Step 4: Filtering by Date Range
  if ((start || end) && Array.isArray(result)) {
    const startDate = start ? new Date(start + 'T00:00:00') : null;
    const endDate = end ? new Date(end + 'T23:59:59') : null;
    result = result.filter(item => {
      const rawDate = item.end || item.start || item.dueDate || item.createdAt;
      if (!rawDate) return false;
      const itemDate = new Date(rawDate);
      if (isNaN(itemDate)) return false;
      if (startDate && !endDate) {
        const itemDay = itemDate.toISOString().slice(0, 10);
        return itemDay === start;
      }
      if (!startDate && endDate) {
        const itemDay = itemDate.toISOString().slice(0, 10);
        return itemDay === end;
      }
      if (startDate && endDate) {
        return itemDate >= startDate && itemDate <= endDate;
      }
      return true;
    });
  }

  // Step 5: Filtering by `orderby`
  if (orderby && Array.isArray(result)) {
    result = result.filter(item => item[orderby] !== undefined && item[orderby] !== '');
    if (sort) {
      result = result.sort((a, b) => {
        if (a[orderby] < b[orderby]) return sort === 'ASC' ? -1 : 1;
        if (a[orderby] > b[orderby]) return sort === 'ASC' ? 1 : -1;
        return 0;
      });
    }
  }

  // Step 6: Enrichment (relate)
  if (relate && result) {
    if (Array.isArray(result)) {
      result = result.map(item => (typeof item === 'string' ? enrichField(item, relate) : enrichItem(item, relate)));
    } else {
      result = typeof result === 'string' ? enrichField(result, relate) : enrichItem(result, relate);
    }
  }

  // Step 7: Get specific field
  if (get) {
    if (Array.isArray(result)) {
      result = result.map(item => (item[get] !== undefined ? item[get] : null));
    } else {
      result = result[get] !== undefined ? result[get] : null;
    }
  }

  return result || [];
}

// Funzione di arricchimento, con un controllo di profondità
function enrichItem(item, relate = false, depth = 0, seen = new Set()) {
  if (depth > 8) return item; // Limite di profondità

  let enrichedItem = { ...item };

  Object.keys(enrichedItem).forEach(key => {
    const value = enrichedItem[key];

    // Arricchisci solo se il valore è un array di ID
    if (Array.isArray(value) && (relate === true || (Array.isArray(relate) && relate.includes(key)))) {
      if (!seen.has(value)) {
        seen.add(value);
        enrichedItem[key] = value.map(id => enrichField(id, relate, depth + 1, seen));
      }
    }
    // Se il valore è un oggetto, arricchiscilo ricorsivamente
    else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      enrichedItem[key] = enrichItem(value, relate, depth + 1, seen);
    }
  });

  return enrichedItem;
}

// Funzione per arricchire un campo specifico (in particolare gli ID)
function enrichField(id, relate = false, depth = 0, seen = new Set()) {
  if (depth > 8) return id;
  if (typeof id !== 'string') return id;
  const [type, idValue] = id.split('-');
  let db = database();
  if (db[type]) {
    const foundItem = db[type].find(item => item.id === id);
    if (foundItem) {
      return enrichItem(foundItem, relate, depth, seen);
    }
  }
  return id;
}

//console.log("Test 1: Search by ID search({ id: 'tasks-1220'})");
//console.log('Test 1 Result:', search({ id: 'tsk-4', relate: ['tsk']}));
//console.log('Test 1 with buildTree:', buildTree(search({ id: 'tsk-4', relate: ['tsk']})));

//
//console.log("Test 2: Search by type search({ type: 'tasks' })");
//const result2 = search({ type: 'tasks' });
//console.log('Test 2 Result:', result2);
//
//console.log("Test 3: Search by root search({ type: ['settings', 'bank', 'name']' })");
//const result3 = search({ type: ['settings', 'bank', 'name']' });
//console.log('Test 3 Result:', result3);
//
//console.log("Test 4: Search by type and sort search({ type: 'tasks', orderby: 'end_date', sort: 'ASC' })");
//const result4 = search({ type: 'tasks', orderby: 'end_date', sort: 'ASC' });
//console.log('Test 4 Result:', result4);
//
//console.log("Test 5: Search by ID and rich all fields search({ id: 'tasks-1220', relate: true })");
//const result5 = search({ id: 'tasks-1220', relate: true });
//console.log('Test 5 Result:', result5);
//
//console.log("'Test 6: Search by ID and rich only comments and tags search({ id: 'tasks-1220', relate: ['comments', 'tags'] })");
//const result6 = search({ id: 'tasks-1220', relate: ['comments', 'tags'] });
//console.log('Test 6 Result:', result6);
//
//console.log("Test 7: Search single object and rich the content search({ type: '["settings", "style", "logo"]', relate: ['link'], get: 'link'})");
//const result7 = search({ type: '["settings", "style", "logo"]', relate: ['link'], get: 'link'});
//console.log('Test 7 Result:', result7);
//
//console.log("Test 8: Ricavo la rubrica dinamica search({ type: 'cnt', orderby: 'phone', relate: ['cmp']})");
//const result8 = search({ type: 'cnt', orderby: 'phone', relate: ['cmp']});
//console.log('Test 8 Result:', result8);
//
//console.log(JSON.stringify(search({ id: 'tasks-1220', relate: ["comments", "tags", "prf", "avatar"] }), null, 2));

function get_new_id() {
  return Math.floor(10000000 + Math.random() * 90000000);
}

function demo_new_comment(body) {
  let usr = get_prf();
  return [
    {
      id: '56565656',
      title: body.data,
      time: now_date + ' ' + now_hour + ':' + now_minute,
      avatar_icon: usr[0]['avatar'],
      avatar_link: usr[0]['link'],
      avatar_title: usr[0]['title'],
      description: usr[0]['title'],
      class: 'my-comment'
    }
  ];
}

function seedDatabase() {
  return {
    // Calls
    cll: [
      {
        id: 'cll-1',
				type: 'calls',
        title: 'Chiamata cliente Rossi',
        call_start: '2025-06-10T10:00:00Z',
        call_end: '2025-06-10T10:07:30Z',
        duration: 450,
        direction: 'outbound',
        disposition: 'answered',
        caller_id: '+390212345678',
        callee_id: '+393334445555',
        wtsnew: true
      },
      {
        id: 'cll-2',
				type: 'calls',
        title: 'Assistenza tecnica',
        call_start: '2025-06-11T15:00:00Z',
        call_end: '2025-06-11T15:02:00Z',
        duration: 120,
        direction: 'inbound',
        disposition: 'missed',
        caller_id: '+393331234567',
        callee_id: '+390289912345'
      },
      {
        id: 'cll-3',
				type: 'calls',
        title: 'Follow-up preventivo',
        call_start: '2025-06-12T09:30:00Z',
        call_end: '2025-06-12T09:38:10Z',
        duration: 490,
        direction: 'outbound',
        disposition: 'answered',
        caller_id: '+390212345600',
        callee_id: '+393336667777',
        wtsnew: true
      }
    ],
    // Company
    cmp: [
      {
        id: 'cmp-1',
				type: 'companies',
        is_owner: true,
        title: 'Teknology',
        logo: ['fls-1'],
        profiles: ['prf-3', 'prf-4'],
        legal: {
          name: 'MComunication LTD',
          vat_number: 'IT12345678901',
          fiscal_code: '12345678901',
          sdi: 'SDI FRTA9F7',
          pec: ['cnt-5'],
          address: 'j.k. Spartak',
          city: 'Sandanski',
          post_code: '2800',
          province: 'MI',
          country: 'Italia'
        },
        shipping: {
          address: 'ul. Sarsinian 8',
          city: 'Sandanski',
          post_code: '2800',
          province: 'BL',
          country: 'Bulgaria'
        },
        notes: 'Partner strategico dal 2022. In crescita.',
        created: '2025-06-16T10:00:00Z',
        updated: '2025-06-16T10:00:00Z',
        wtsnew: true
      },
      {
        id: 'cmp-2',
				type: 'companies',
        title: 'Innovatika',
        logo: ['fls-3'],
        profiles: ['prf-2', 'prf-1'],
        legal: {
          name: 'Innovatika GmbH',
          vat_number: 'DE9988776655',
          fiscal_code: '9988776655',
          sdi: 'SDI XZTG12A',
          pec: ['cnt-12'],
          address: 'Berliner Allee 45',
          city: 'Düsseldorf',
          post_code: '40212',
          province: 'NW',
          country: 'Germania'
        },
        shipping: {
          address: 'Königsallee 78',
          city: 'Düsseldorf',
          post_code: '40215',
          province: 'NW',
          country: 'Germania'
        },
        notes: 'Cliente chiave nel settore automotive. Focus su soluzioni IoT.',
        created: '2025-06-16T10:00:00Z',
        updated: '2025-06-16T10:00:00Z'
      },
      {
        id: 'cmp-3',
				type: 'companies',
        title: 'Piero Muscari Storytailor',
        logo: ['fls-3'],
        profiles: ['prf-2', 'prf-1'],
        legal: {
          name: 'Duepuntozero srls',
          vat_number: 'DE9988776655',
          fiscal_code: '9988776655',
          sdi: 'SDI XZTG12A',
          pec: ['cnt-12'],
          address: 'Berliner Allee 45',
          city: 'Düsseldorf',
          post_code: '40212',
          province: 'NW',
          country: 'Germania'
        },
        shipping: {
          address: 'Königsallee 78',
          city: 'Düsseldorf',
          post_code: '40215',
          province: 'NW',
          country: 'Germania'
        },
        notes: 'Cliente chiave nel settore marketing. Focus sullo storytelling.',
        created: '2025-06-16T10:00:00Z',
        updated: '2025-06-16T10:00:00Z'
      }
    ],
    // Contacts
    cnt: [
      {
        id: 'cnt-1',
        title: 'Info - Mio Sito',
        first_name: 'Info',
        last_name: 'Mio Sito',
        value: 'info@miosito.it',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-1', 'tgs-4'],
        method: ['email'],
        created_at: '2024-12-15T09:00:00Z',
        updated_at: '2025-08-10T10:00:00Z'
      },
      {
        id: 'cnt-2',
        title: 'Marco Suriani',
        first_name: 'Marco',
        last_name: 'Suriani',
        value: '+393281234567',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-2', 'tgs-5'],
        method: ['call', 'sms', 'whatsapp'],
        created_at: '2024-12-20T10:00:00Z',
        updated_at: '2025-08-12T09:30:00Z'
      },
      {
        id: 'cnt-3',
        title: 'Giulia Bianchi',
        first_name: 'Giulia',
        last_name: 'Bianchi',
        value: 'giulia.bianchi@client.com',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-2', 'tgs-5'],
        method: ['email'],
        created_at: '2024-12-21T11:00:00Z',
        updated_at: '2025-08-11T12:15:00Z'
      },
      {
        id: 'cnt-4',
        title: 'Office Linea 1',
        first_name: 'Office',
        last_name: 'Linea 1',
        value: '+39028745032',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-1'],
        method: ['call', 'fax'],
        created_at: '2024-12-18T08:30:00Z',
        updated_at: '2025-08-09T14:00:00Z'
      },
      {
        id: 'cnt-5',
        title: 'Pec Azienda',
        first_name: 'Pec',
        last_name: 'Azienda',
        value: 'miapec@pec.com',
				type: 'contacts',
        contact_type: 'pec',
        tags: ['tgs-1', 'tgs-6'],
        method: ['pec'],
        created_at: '2024-12-15T09:45:00Z',
        updated_at: '2025-08-10T15:00:00Z'
      },
      {
        id: 'cnt-6',
        title: 'Telegram Marco',
        first_name: 'Marco',
        last_name: 'Telegram',
        value: '@marco_s',
				type: 'contacts',
        contact_type: 'telegram',
        tags: ['tgs-2', 'tgs-7'],
        method: ['telegram'],
        created_at: '2025-01-05T12:00:00Z',
        updated_at: '2025-08-11T09:00:00Z'
      },
      {
        id: 'cnt-7',
        title: 'WhatsApp Giulia',
        first_name: 'Giulia',
        last_name: 'WhatsApp',
        value: '+393491234567',
				type: 'contacts',
        contact_type: 'whatsapp',
        tags: ['tgs-2', 'tgs-7'],
        method: ['whatsapp'],
        created_at: '2025-01-06T14:00:00Z',
        updated_at: '2025-08-11T11:00:00Z'
      },
      {
        id: 'cnt-8',
        title: 'Supporto IT',
        first_name: 'Supporto',
        last_name: 'IT',
        value: 'support@azienda.it',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-1', 'tgs-3'],
        method: ['email'],
        created_at: '2025-02-01T09:00:00Z',
        updated_at: '2025-08-10T10:45:00Z'
      },
      {
        id: 'cnt-9',
        title: 'Alice Rossi',
        first_name: 'Alice',
        last_name: 'Rossi',
        value: '+393401112233',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-2', 'tgs-5'],
        method: ['call', 'sms'],
        created_at: '2025-02-10T10:30:00Z',
        updated_at: '2025-08-12T10:00:00Z'
      },
      {
        id: 'cnt-10',
        title: 'PEC Innovatika',
        first_name: 'PEC',
        last_name: 'Innovatika',
        value: 'innovatika@pec.com',
				type: 'contacts',
        contact_type: 'pec',
        tags: ['tgs-1', 'tgs-6'],
        method: ['pec'],
        created_at: '2025-02-15T09:15:00Z',
        updated_at: '2025-08-10T10:30:00Z'
      },
      {
        id: 'cnt-11',
        title: 'Fax Azienda',
        first_name: 'Fax',
        last_name: 'Azienda',
        value: '+39028745123',
				type: 'contacts',
        contact_type: 'fax',
        tags: ['tgs-1'],
        method: ['fax'],
        created_at: '2025-03-01T08:00:00Z',
        updated_at: '2025-08-10T09:00:00Z'
      },
      {
        id: 'cnt-12',
        title: 'Luca Bianchi',
        first_name: 'Luca',
        last_name: 'Bianchi',
        value: '+393481112233',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-2', 'tgs-5'],
        method: ['call', 'sms', 'telegram'],
        created_at: '2025-03-05T12:15:00Z',
        updated_at: '2025-08-11T14:00:00Z'
      },
      {
        id: 'cnt-13',
        title: 'Marketing Email',
        first_name: 'Marketing',
        last_name: 'Team',
        value: 'marketing@azienda.it',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-1', 'tgs-4'],
        method: ['email'],
        created_at: '2025-03-10T09:30:00Z',
        updated_at: '2025-08-10T12:00:00Z'
      },
      {
        id: 'cnt-14',
        title: 'Franco Cerioli',
        first_name: 'Franco',
        last_name: 'Cerioli',
        value: 'franco@clientspa.it',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-2', 'tgs-5'],
        method: ['email'],
        created_at: '2025-03-12T10:00:00Z',
        updated_at: '2025-08-11T10:45:00Z'
      },
      {
        id: 'cnt-15',
        title: 'Personal Cell',
        first_name: 'Personal',
        last_name: 'Cell',
        value: '+393421547896',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-2', 'tgs-7'],
        method: ['call', 'sms', 'telegram'],
        created_at: '2025-03-15T11:00:00Z',
        updated_at: '2025-08-11T11:30:00Z'
      },
      {
        id: 'cnt-16',
        title: 'Support Chat',
        first_name: 'Support',
        last_name: 'Chat',
        value: '@support_team',
				type: 'contacts',
        contact_type: 'telegram',
        tags: ['tgs-1', 'tgs-3'],
        method: ['telegram'],
        created_at: '2025-03-20T09:30:00Z',
        updated_at: '2025-08-10T12:30:00Z'
      },
      {
        id: 'cnt-17',
        title: 'Cell Ufficio',
        first_name: 'Cell',
        last_name: 'Ufficio',
        value: '+3903450685470',
				type: 'contacts',
        contact_type: 'phone',
        tags: ['tgs-1'],
        method: ['call', 'sms', 'whatsapp'],
        created_at: '2025-03-25T08:45:00Z',
        updated_at: '2025-08-10T11:15:00Z'
      },
      {
        id: 'cnt-18',
        title: 'Customer Service',
        first_name: 'Customer',
        last_name: 'Service',
        value: 'service@client.com',
				type: 'contacts',
        contact_type: 'email',
        tags: ['tgs-1', 'tgs-3'],
        method: ['email'],
        created_at: '2025-04-01T10:00:00Z',
        updated_at: '2025-08-10T13:00:00Z'
      },
      {
        id: 'cnt-19',
        title: 'WhatsApp Support',
        first_name: 'Support',
        last_name: 'WhatsApp',
        value: '+393491234568',
				type: 'contacts',
        contact_type: 'whatsapp',
        tags: ['tgs-1', 'tgs-3'],
        method: ['whatsapp'],
        created_at: '2025-04-05T09:15:00Z',
        updated_at: '2025-08-10T13:30:00Z'
      },
      {
        id: 'cnt-20',
        title: 'PEC Legale',
        first_name: 'PEC',
        last_name: 'Legale',
        value: 'legale@pec.it',
				type: 'contacts',
        contact_type: 'pec',
        tags: ['tgs-6'],
        method: ['pec'],
        created_at: '2025-04-10T10:00:00Z',
        updated_at: '2025-08-10T14:00:00Z'
      }
    ],
    // Emails
    eml: [
      {
        id: 'eml-1',
				type: 'emails',
        title: 'Conferma iscrizione newsletter',
        from: ['cnt-1'],
        to: ['cnt-6'],
        date: '2025-06-01T10:30:00Z',
        status: 'sent',
        body: '<p>Grazie per esserti iscritto alla nostra newsletter! Riceverai aggiornamenti e promozioni esclusive.</p>',
        attachments: [],
        priority: 'normal',
        wtsnew: true
      },
      {
        id: 'eml-2',
				type: 'emails',
        title: 'Richiesta informazioni prodotto',
        from: ['cnt-6'],
        to: ['cnt-1', 'cnt-5'],
        date: '2025-06-03T09:00:00Z',
        status: 'received',
        body: '<p>Buongiorno, vorrei ricevere maggiori informazioni sul vostro prodotto <strong>A123</strong>. Attendo riscontro, grazie.</p>',
        attachments: [],
        priority: 'high',
        wtsnew: false
      },
      {
        id: 'eml-3',
				type: 'emails',
        title: 'Reminder riunione',
        from: ['cnt-5'],
        to: ['cnt-1', 'cnt-6'],
        date: '2025-06-05T14:00:00Z',
        status: 'sent',
        body: '<p>Vi ricordiamo la riunione prevista per domani alle ore <strong>10:00</strong> in sala conferenze.</p>',
        attachments: [],
        priority: 'normal',
        wtsnew: true
      },
      {
        id: 'eml-4',
				type: 'emails',
        title: 'Bozza proposta commerciale',
        from: ['cnt-5'],
        to: ['cnt-6'],
        date: '2025-06-06T17:00:00Z',
        status: 'draft',
        body: '<p>Gentile cliente, in allegato trova la bozza della proposta commerciale come da accordi.</p>',
        attachments: ['proposta.pdf'],
        priority: 'normal',
        wtsnew: true
      }
    ],
    // Events
    evn: [
      {
        id: 'evn-1',
        title: 'Meeting with client',
        notes: 'Portare il materiale aggiornato e personalizzato.',
        start: '2025-06-15T14:00:00',
        end: '2025-06-15T14:00:00',
				type: 'events',
        event_type: 'meeting',
        location: 'Google Meet',
        link: 'https://meet.google.com/xyz-abc-def',
        timezone: 'Europe/Rome',
        organizer: ['cnt-1'],
        attendees: ['cnt-5', 'cnt-6'],
        related: ['tsk-1'],
        reminders: [
          { via: 'email', end: '2025-06-15T14:00:00', attendees: ['cnt-1'] },
          { via: 'sms', end: '2025-06-15T14:00:00', attendees: ['cnt-5', 'cnt-6'] }
        ],
        status: 'scheduled',
        visibility: 'private',
        created: '2025-06-16T11:00:00Z',
        updated: '2025-06-16T11:30:00Z'
      },
      {
        id: 'evn-2',
        title: 'Rilascio versione 2.0',
        notes: 'Controllare il changelog finale e inviare comunicazione ai clienti.',
        start: '2025-06-16T00:00:01',
        end: '2025-06-17T23:59:59',
				type: 'events',
        event_type: 'milestone',
        location: 'Sala B - HQ Milano',
        link: null,
        timezone: 'Europe/Rome',
        all_day: true,
        organizer: ['cnt-6'],
        attendees: ['cnt-5', 'cnt-1'],
        related_to: ['tasks-2', 'cmp-1'],
        reminders: ['reminders-3'],
        status: 'scheduled',
        visibility: 'internal',
        created: '2025-06-16T08:30:00Z',
        updated: '2025-06-16T09:00:00Z'
      },
      {
        id: 'evn-3',
        title: 'Webinar: Strategie di crescita 2025',
        notes: 'Preparare slide, inviare link agli iscritti entro il 10 maggio.',
        start: '2025-05-17T14:00:00',
        end: '2025-05-17T16:00:00',
				type: 'events',
        event_type: 'webinar',
        location: 'Zoom',
        link: 'https://zoom.us/j/9876543210',
        timezone: 'Europe/Rome',
        all_day: false,
        organizer: ['prf-1'],
        attendees: ['cnt-5', 'cnt-12', 'cnt-18'],
        related: ['cmp-2'],
        reminders: ['reminders-2'],
        status: 'completed',
        visibility: 'public',
        created: '2025-05-01T10:00:00Z',
        updated: '2025-05-17T17:00:00Z'
      }
    ],
    // Invoices
    inv: [
      {
        id: 'inv-2024-00123',
        invoice_number: 'FATT-2024-00123',
        type: 'invoices', // oppure: "acconto", "nota_credito"
        status: 'inviata', // oppure: "bozza", "pagata", "annullata"
        issue_date: '2024-05-30',
        due_date: '2024-06-30',
        payment_date: null,
        currency: 'EUR',
        language: 'it',
        payment_method: 'bonifico',
        iban: 'IT60X0542811101000000123456',
        payment_terms: '30 giorni fine mese',
        title: 'Fattura per consulenza IT - maggio 2024',
        description: 'Fattura relativa ai servizi di consulenza erogati nel mese di maggio.',

        client: {
          id: 'clt-00101',
          name: 'Client S.p.A.',
          vat_number: 'IT01234567890',
          fiscal_code: '01234567890',
          recipient_code: 'ABC1234',
          pec: 'clientspa@pec.it',
          address: {
            street: 'Via Roma 10',
            postal_code: '00100',
            city: 'Roma',
            province: 'RM',
            country: 'IT'
          }
        },

        supplier: {
          id: 'sup-00001',
          name: 'Tech Studio di Marco Suriani',
          vat_number: 'IT12345678901',
          fiscal_code: 'SRNMRC80A01F205X',
          address: {
            street: 'Via Milano 2',
            postal_code: '20100',
            city: 'Milano',
            province: 'MI',
            country: 'IT'
          }
        },

        lines: [
          {
            id: 'line-1',
            description: 'Consulenza software',
            quantity: 10,
            unit: 'h',
            unit_price: 100.0,
            discount: 0,
            tax_rate: 0.22,
            tax_type: 'IVA'
          },
          {
            id: 'line-2',
            description: 'Assistenza remota',
            quantity: 5,
            unit: 'h',
            unit_price: 80.0,
            discount: 0,
            tax_rate: 0.22,
            tax_type: 'IVA'
          }
        ],

        totals: {
          subtotal: 1300.0,
          taxable_amount: 1300.0,
          taxes: [
            {
              rate: 0.22,
              amount: 286.0,
              type: 'IVA'
            }
          ],
          total: 1586.0,
          withholding_tax: 0.0,
          stamp_duty: 2.0,
          grand_total: 1588.0
        },

        electronic_invoice: true,
        transmission_status: 'trasmessa',
        transmission_id: 'sdi-2024-0982',
        pdf_file_id: 'file-123456',
        xml_file_id: 'file-789012',

        notes: 'Bollo virtuale assolto ai sensi del DM 17/06/2014.',

        reminders: [
          {
            reminder_id: 'rem-001',
            send_date: '2024-06-15',
            channel: 'email'
          }
        ],

        created: '2024-05-30T10:00:00Z',
        updated: '2024-05-30T10:05:00Z'
      }
    ],
    // Logs
    lgs: [
      {
        id: 'lgs-1',
				type: 'log',
        related: ['evn-3'],
        created: '2025-01-15T08:00:00Z',
        prf: ['prf-125']
      },
      {
        id: 'lgs-2',
				type: 'log',
        modified: '2025-01-18T10:00:00Z',
        prf: ['prf-126']
      },
      {
        id: 'lgs-3',
				type: 'log',
        title: 'Meeting with client at 11.00',
        prf: ['prf-126']
      }
    ],
    // Projects lists
    lst: [
      {
        id: 'lst-1',
				type: 'lists',
        title: 'List 1',
        description: 'This Is Only An Example',
        prf: ['prf-126']
      },
      {
        id: 'lst-2',
				type: 'lists',
        title: 'List 2',
        description: 'This Is Only An Example',
        prf: ['prf-125']
      }
    ],
    // Files
    fls: [
      {
        id: 'fls-1',
				type: 'image',
        format: 'image/png',
				title: 'Logo-2024_logo-copia-4-1536x406.png',
        link: 'https://teknology.eu/wp-content/uploads/2021/10/Logo-2024_logo-copia-4-1536x406.png',
        shares: ['prf-2']
      },
      {
        id: 'fls-2',
				type: 'image',
        format: 'image/jpg',
				title: 'Logo Solaris',
        link: 'https://teknology.eu/wp-content/uploads/2024/04/Logo-Solaris-quadrato-300x300.jpg',
        shares: ['prf-1']
      },
      {
        id: 'fls-3',
				type: 'image',
        format: 'image/png',
				title: 'pieromuscari-logo-1-300x300.png',
        link: 'https://teknology.eu/wp-content/uploads/2024/04/pieromuscari-logo-1-300x300.png'
      },
      {
        id: 'fls-4',
				type: 'image',
        format: 'image/jpg',
				title: 'Logo-2024_logo-copia-4.jpg',
        link: 'https://teknology.eu/wp-content/uploads/2024/04/Logo-2024_logo-copia-4.jpg'
      },
      {
        id: 'fls-5',
				type: 'image',
        format: 'image/jpg',
				title: 'Avatar generico',
        link: 'https://us.123rf.com/450wm/file404/file4042004/file404200400762/143794459-casual-young-man-looking-back-at-something.jpg'
      },
      {
        id: 'fls-6',
				type: 'image',
        format: 'image/jpg',
				title: 'Home',
        link: 'https://st3.depositphotos.com/10290464/16512/i/450/depositphotos_165127894-stock-photo-handsome-confident-male-with-trendy.jpg'
      },
      {
        id: 'fls-7',
				type: 'image',
        format: 'image/jpg',
				title: 'Ragazza',
        link: 'https://us.123rf.com/450wm/na2xa/na2xa1912/na2xa191200023/134850860-schoolgirl-with-a-smile-of-joyful-admiration-looks-at-the-camera-her-beautiful-teeth-are-visible.jpg'
      },
      {
        id: 'fls-8',
				type: 'image',
        format: 'image/jpg',
				title: 'Logo-2024_logo-copia-150x150.jpg',
        link: 'https://teknology.eu/wp-content/uploads/2021/10/Logo-2024_logo-copia-150x150.jpg'
      },
      {
        id: 'fls-9',
				type: 'audio',
        format: 'audio/mp3',
				title: 'Audio Test',
        link: 'https://www.pieromuscari.it/wp-content/uploads/2019/02/Piero-Muscari-Show-Reel-Audio.mp3'
      }
    ],
    // Profiles (users: role based access)
    prf: [
      {
        id: 'prf-1',
				type: 'profiles',
        slug: 'marco-suriani',
        first_name: 'Marco',
        last_name: 'Suriani',
        full_name: 'Marco Suriani',
        language: 'en',
        role: 'owner',
        cmpy: ['cmp-1'],
        avatar: ['fls-8'],
        gender: 'male',
        last_access: '2025-08-10T10:20:00Z',
        status: 'busy'
      },
      {
        id: 'prf-2',
				type: 'profiles',
        slug: 'benko-kober',
        first_name: 'Benko',
        last_name: 'Kober',
        full_name: 'Benko Kober',
        language: 'it',
        role: 'administrator',
        cmpy: ['cmp-1'],
        avatar: ['fls-5'],
        gender: 'male'
      },
      {
        id: 'prf-3',
				type: 'profiles',
        slug: 'franco-cerioli',
        first_name: 'Franco',
        last_name: 'Cerioli',
        full_name: 'Franco Cerioli',
        role: 'contact',
        cmpy: ['cmp-2'],
        avatar: ['fls-6'],
        address: {
          street: 'via Antondello',
          city: 'Roma',
          postal_code: '7000'
        },
        email: 'franco@clientspa.it',
        phone: '+393280685470'
      },
      {
        id: 'prf-4',
				type: 'profiles',
        slug: 'giulia-bianchi',
        first_name: 'Giulia',
        last_name: 'Bianchi',
        full_name: 'Giulia Bianchi',
        role: 'client',
        job_title: 'Responsabile Acquisti',
        department: 'Procurement',
        avatar: ['fls-7'],
        address: {
          street: 'Via delle Industrie 45',
          city: 'Bologna',
          postal_code: '40100',
          province: 'BO',
          country: 'Italia'
        },
        social: {
          linkedin: 'https://linkedin.com/in/giuliabianchi',
          twitter: '@giuliab'
        },
        language: 'it',
        notes: 'Contatto molto reattivo, preferisce comunicazioni via email nel pomeriggio.',
        created_at: '2025-06-16T10:20:00Z',
        updated_at: '2025-06-16T10:45:00Z',
        cmpy: ['cmp-2'],
        cnt: ['cnt-3']
      }
    ],
    // Projects
    prj: [
      {
        id: 'prj-1',
				type: 'projects',
        title: 'My First Project',
        description: 'This is only an example',
        status: 'in_progress',
        priority: 'medium',
        start_date: '2025-08-01T09:00:00Z',
        due_date: '2025-09-30T18:00:00Z',
        created_at: '2025-07-20T12:00:00Z',
        updated_at: '2025-08-14T10:00:00Z',
        evn: ['evn-1'],
        tsk: ['tsk-1'],
        usr: ['prf-1', 'prf-4'],
        cnt: ['cnt-3', 'cnt-4'],
        cmp: ['cmp-2'],
        tgs: ['tgs-1', 'tgs-5'],
        notes: 'Progetto pilota per testare la nuova struttura dei task',
        attachments: ['fls-1', 'fls-2']
      },
      {
        id: 'prj-2',
				type: 'projects',
        title: 'My Client Project',
        description: 'This is only an example',
        status: 'planning',
        priority: 'high',
        start_date: '2025-08-10T09:00:00Z',
        due_date: '2025-10-15T18:00:00Z',
        created_at: '2025-08-01T10:00:00Z',
        updated_at: '2025-08-14T10:30:00Z',
        evn: ['evn-1234'],
        tasks: ['tsk-2'],
        usr: ['prf-2'],
        cnt: ['cnt-5', 'cnt-6'],
        cmp: ['cmp-3'],
        tags: ['tgs-2', 'tgs-6'],
        milestones: ['evn-2'],
        notes: 'Cliente chiave, priorità alta per rispetto deadline',
        attachments: ['fls-3']
      }
    ],
    // SMS
    sms: [
      {
        id: 'sms-1',
				type: 'sms',
        timestamp: '2025-06-15T12:00:00Z',
        direction: 'inbound',
        from: '+393331112222',
        to: '+390212345678',
        title: 'Buongiorno, avete ricevuto il mio ordine?'
      },
      {
        id: 'sms-2',
				type: 'sms',
        timestamp: '2025-06-15T12:05:00Z',
        direction: 'outbound',
        from: '+390212345678',
        to: '+393331112222',
        title: 'Sì, il tuo ordine è stato ricevuto e sarà elaborato a breve.'
      },
      {
        id: 'sms-3',
				type: 'sms',
        timestamp: '2025-06-16T09:30:00Z',
        direction: 'inbound',
        from: '+393339998888',
        to: '+390212345678',
        title: 'Salve, potrei avere assistenza?'
      }
    ],
    // Settings
    stt: {
      style: {
        logo: ['fls-1'],
        logo_mini: ['fls-2']
      },
      bank: {
        name: 'Azienda S.r.l.',
        bic: '',
        iban: 'IT12A3456789012345678901234'
      },
      invoice_note: 'Thank you for choosing us! Please make payment within 30 days of the invoice date.'
    },
    // Tags
    tgs: [
      {
        id: 'tgs-1',
				type: 'tags',
        name: 'PHP',
        color: '#254789'
      },
      {
        id: 'tgs-2',
				type: 'tags',
        name: 'CSS',
        color: '#963587'
      },
      {
        id: 'tgs-3',
				type: 'tags',
        name: 'HTML',
        color: '#252525'
      }
    ],
    // Timeline
    tml: ['cll-3', 'tsk-1', 'tsk-4', 'vdc-2', 'tlg-2', 'fls-9', 'wts-3', 'tsk-5', 'sms-1', 'prj-2', 'fls-2', 'evn-1', 'tsk-8', 'eml-1', 'cmp-1', 'inv-2024-00123'],
    // Tasks
    tsk: [
      {
        id: 'tsk-1',
				type: 'tasks',
        title: '11Meeting with client at 12.00',
        end: '2025-05-20T14:00:00',
        prj: ['prj-1'],
        lst: ['lst-1'],
        tgs: ['tgs-1', 'tgs-2', 'tgs-3'],
        evn: ['evn-1'],
        comments: [
          {
            id: 'com-1',
            created_at: '2025-06-16T09:45:00Z',
            updated_at: '2025-06-16T09:45:00Z',
            title:
              'As we spoke yesterday, I make the new graphic design for the site but still incomplete because the owner is not confirm if everything is ok.',
            author: ['prf-1'],
            mentions: ['prf-2'],
            attachments: ['fls-2']
          },
          {
            id: 'com-2',
            title: 'Can you upload the conversation?',
            author: ['prf-1']
          },
          {
            id: 'com-3',
            title: 'Yes!',
            author: ['prf-1']
          }
        ]
      },
      {
        id: 'tsk-2',
				type: 'tasks',
        title: 'Conference with team at 10.00',
        end: '2025-05-16T14:00:00',
        prj: ['prj-1'],
        lst: ['lst-1'],
        tgs: ['tgs-1'],
        reminders: [
          {
            id: 'reminders-1',
            date: '2024-10-08',
            time: '10:00 AM',
            person: 'Antony',
            method: 'email'
          },
          {
            id: 'reminders-2',
            date: '2024-10-07',
            time: '2:00 PM',
            person: 'Bridge',
            method: 'sms'
          }
        ]
      },
      {
        id: 'tsk-3',
				type: 'tasks',
        title: 'Logo creation',
        end: '2025-05-16T14:00:00',
        prj: ['prj-2'],
        lst: ['lst-2'],
        prf: ['prf-2', 'prf-4'],
        completed: true
      },
      {
        id: 'tsk-4',
				type: 'tasks',
        title: 'Task Principale 4',
        end: '2025-07-31T12:29:20',
        prf: ['prf-2'],
        tgs: ['tgs-4', 'tgs-104'],
        completed: false,
        tsk: ['tsk-9'],
        prj: ['prj-1'],
        lst: ['lst-1']
      },
      {
        id: 'tsk-5',
				type: 'tasks',
        title: 'Task Principale 5',
        end: '2025-08-01T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-2'],
        prf: ['prf-1', 'prf-2', 'prf-3', 'prf-4'],
        tgs: ['tgs-5', 'tgs-105'],
        completed: false,
        tsk: ['tsk-10']
      },
      {
        id: 'tsk-6',
				type: 'tasks',
        title: 'Task Principale 6',
        end: '2025-08-02T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-2'],
        prf: ['prf-1'],
        tgs: ['tgs-6', 'tgs-106'],
        completed: false,
        tsk: ['tsk-11']
      },
      {
        id: 'tsk-7',
				type: 'tasks',
        title: 'Task Principale 7',
        end: '2025-08-03T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-1'],
        prf: ['prf-2'],
        tgs: ['tgs-7', 'tgs-107'],
        completed: false,
        tsk: ['tsk-12']
      },
      {
        id: 'tsk-8',
				type: 'tasks',
        title: 'Task Principale 8',
        end: '2025-08-04T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-1'],
        prf: ['prf-3'],
        tgs: ['tgs-8', 'tgs-108'],
        completed: false,
        tsk: ['tsk-13']
      },
      {
        id: 'tsk-9',
				type: 'tasks',
        title: 'Sotto-Task 9 di tsk-4',
        end: '2025-08-05T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-1'],
        prf: ['prf-1'],
        tgs: ['tgs-9', 'tgs-109'],
        completed: false,
        tsk: ['tsk-14']
      },
      {
        id: 'tsk-10',
				type: 'tasks',
        title: 'Sotto-Task 10 di tsk-5',
        end: '2025-08-06T12:29:20',
        prj: ['prj-1'],
        lst: ['lst-2'],
        prf: ['prf-2'],
        tgs: ['tgs-10', 'tgs-110'],
        completed: false,
        tsk: ['tsk-15']
      },
      {
        id: 'tsk-11',
				type: 'tasks',
        title: 'Sotto-Task 11 di tsk-6',
        end: '2025-08-07T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-1'],
        prf: ['prf-3'],
        tgs: ['tgs-11', 'tgs-111'],
        completed: false,
        tsk: ['tsk-16']
      },
      {
        id: 'tsk-12',
				type: 'tasks',
        title: 'Sotto-Task 12 di tsk-7',
        end: '2025-08-08T12:29:20',
        prj: ['prj-2'],
        lst: ['lst-1'],
        prf: ['prf-1'],
        tgs: ['tgs-12', 'tgs-112'],
        completed: false,
        tsk: ['tsk-17']
      },
      {
        id: 'tsk-13',
				type: 'tasks',
        title: 'Sotto-Task 13 di tsk-8',
        end: '2025-08-09T12:29:20',
        prf: ['prf-2'],
        tgs: ['tgs-13', 'tgs-113'],
        completed: false,
        tsk: ['tsk-18'],
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-14',
				type: 'tasks',
        title: 'Sotto-Sotto-Task 14 di tsk-9',
        end: '2025-08-10T12:29:20',
        prf: ['prf-3'],
        tgs: ['tgs-14', 'tgs-114'],
        completed: false,
        prj: ['prj-1'],
        lst: ['lst-1']
      },
      {
        id: 'tsk-15',
				type: 'tasks',
        title: 'Sotto-Sotto-Task 15 di tsk-10',
        end: '2025-08-11T12:29:20',
        prf: ['prf-1'],
        tgs: ['tgs-15', 'tgs-115'],
        completed: false,
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-16',
				type: 'tasks',
        title: 'Sotto-Sotto-Task 16 di tsk-11',
        end: '2025-08-12T12:29:20',
        prf: ['prf-2'],
        tgs: ['tgs-16', 'tgs-116'],
        completed: false,
        prj: ['prj-1'],
        lst: ['lst-1']
      },
      {
        id: 'tsk-17',
				type: 'tasks',
        title: 'Sotto-Sotto-Task 17 di tsk-12',
        end: '2025-08-13T12:29:20',
        prf: ['prf-3'],
        tgs: ['tgs-17', 'tgs-117'],
        completed: false,
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-18',
				type: 'tasks',
        title: 'Sotto-Sotto-Task 18 di tsk-13',
        end: '2025-08-14T12:29:20',
        prf: ['prf-1'],
        tgs: ['tgs-18', 'tgs-118'],
        completed: false,
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-19',
				type: 'tasks',
        title: 'Task Aggiuntiva 19',
        end: '2025-08-15T12:29:20',
        prf: ['prf-2'],
        tgs: ['tgs-19', 'tgs-119'],
        completed: false,
        prj: ['prj-1'],
        lst: ['lst-1']
      },
      {
        id: 'tsk-20',
				type: 'tasks',
        title: 'Task Aggiuntiva 20',
        end: '2025-08-16T12:29:20',
        prf: ['prf-3'],
        tgs: ['tgs-20', 'tgs-120'],
        completed: false,
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-21',
				type: 'tasks',
        title: 'Task Aggiuntiva 21',
        end: '2025-08-17T12:29:20',
        prf: ['prf-1'],
        tgs: ['tgs-21', 'tgs-121'],
        completed: false,
        prj: ['prj-1'],
        lst: ['lst-1']
      },
      {
        id: 'tsk-22',
				type: 'tasks',
        title: 'Task Aggiuntiva 22',
        end: '2025-08-18T12:29:20',
        prf: ['prf-2'],
        tgs: ['tgs-22', 'tgs-122'],
        completed: false,
        prj: ['prj-2'],
        lst: ['lst-2']
      },
      {
        id: 'tsk-23',
				type: 'tasks',
        title: 'Task Aggiuntiva 23',
        end: '2025-08-19T12:29:20',
        prf: ['prf-3'],
        tgs: ['tgs-23', 'tgs-123'],
        completed: false,
        prj: ['prj-1'],
        lst: ['lst-1']
      }
    ],
    // Telegram
    tlg: [
      {
        id: 'tlg-1',
        timestamp: '2025-06-15T10:20:00Z',
        from: 'cnt-100',
        to: 'prf-1',
        type: 'telegram',
        title: 'Ciao, posso inviarti i file qui?'
      },
      {
        id: 'tlg-2',
        timestamp: '2025-06-15T10:22:00Z',
        from: 'prf-1',
        to: 'cnt-100',
        type: 'telegram',
        title: 'Sì certo, va benissimo su Telegram.'
      },
      {
        id: 'tlg-3',
        timestamp: '2025-06-15T10:25:00Z',
        from: 'cnt-100',
        to: 'prf-1',
        type: 'telegram',
        title: 'Perfetto, grazie!'
      }
    ],
    // Videocall
    vdc: [
      {
        id: 'vdc-1',
				type: 'videocalls',
        title: 'Videochiamata con cliente A',
        start: '2025-06-12T14:00:00Z',
        end: '2025-06-12T14:30:00Z',
        participants: ['prf-1', 'cnt-10'],
        duration: 1800,
        platform: 'Zoom',
        status: 'completed'
      },
      {
        id: 'vdc-2',
				type: 'videocalls',
        title: 'Meeting interno settimanale',
        start: '2025-06-13T09:00:00Z',
        end: '2025-06-13T09:45:00Z',
        participants: ['prf-1', 'prf-2', 'prf-3'],
        platform: 'Google Meet',
        status: 'completed'
      },
      {
        id: 'vdc-3',
				type: 'videocalls',
        title: 'Demo prodotto',
        start: '2025-06-14T16:00:00Z',
        end: '2025-06-14T16:20:00Z',
        participants: ['prf-1', 'cnt-55'],
        platform: 'Microsoft Teams',
        status: 'completed'
      }
    ],
    // VoiceMail
    vom: [
      {
        id: 'vom-1',
				type: 'voicemail',
        caller: {
          name: 'Mario Rossi',
          phone_number: '+393331234567'
        },
        timestamp: '2025-08-06T14:23:45Z',
        duration_seconds: 42,
        audio: {
          url: 'https://voipprovider.com/voicemails/vm_20250806_123456.mp3',
          format: 'mp3',
          size_bytes: 106000
        },
        transcription: {
          language: 'it-IT',
          status: 'completed',
          confidence: 0.92,
          text: "Ciao, volevo solo lasciarti un messaggio per confermare l'appuntamento di domani alle 10. A presto."
        },
        read: false,
        tags: ['segreteria', 'appuntamento']
      }
    ],
    // WhatsApp
    wts: [
      {
        id: 'wts-1',
				type: 'whatsapp',
        created: '2025-06-14T08:30:00Z',
        direction: 'inbound',
        from: ['cnt-001'],
        to: ['prf-001'],
        title: 'Ciao! Hai ricevuto il documento?'
      },
      {
        id: 'wts-2',
        created: '2025-06-14T08:45:00Z',
        type: 'whatsapp',
        direction: 'outbound',
        from: ['prf-001'],
        to: ['cnt-001'],
        title: 'Sì, ricevuto. Ti faccio sapere entro domani.'
      },
      {
        id: 'wts-3',
        created: '2025-06-15T09:00:00Z',
        type: 'whatsapp',
        direction: 'inbound',
        from: ['cnt-002'],
        to: ['prf-001'],
        title: "Buongiorno, ci sentiamo alle 10:00 come d'accordo?"
      }
    ]
  };
}

const DB = seedDatabase();

function database() {
  return DB;
}

// Mutation helpers used by the demo API layer.
export function createEntity(type: string, payload: any) {
  const normalized = normalizePayload(type, payload);
  if (!DB[type]) {
    DB[type] = [];
  }
  DB[type].push(normalized);
  addToTimeline(normalized.id, type);
  return normalized;
}

export function addBulkTasks(lines: string[], defaults: any = {}) {
  const added = [];
  lines.forEach(line => {
    const title = line.replace(/^-+\s*/, '').trim();
    if (!title) return;
    added.push(createEntity('tsk', { ...defaults, title }));
  });
  return added;
}

export function completeTask(id: string, completed = true) {
  const task = findById('tsk', id);
  if (task) {
    task.completed = completed;
    return task;
  }
  return null;
}

function addToTimeline(id: string, type: string) {
  if (!Array.isArray(DB.tml)) {
    DB.tml = [];
  }
  DB.tml.unshift(id);
}

function normalizePayload(type: string, payload: any = {}) {
  const prefix = typePrefix(type);
  const nowISO = new Date().toISOString();
  const id = payload.id || generateId(prefix);
  if (type === 'tsk') {
    return {
      id,
      type: 'tasks',
      title: payload.title || 'Untitled task',
      description: payload.description || payload.message || '',
      end: payload.end || payload.dueDate || nowISO,
      prj: toArray(payload.prj || payload.project),
      lst: toArray(payload.lst || payload.list),
      prf: toArray(payload.prf || payload.assignees),
      tgs: toArray(payload.tgs || payload.tags),
      completed: !!payload.completed,
      comments: payload.comments || [],
      created_at: nowISO
    };
  }
  if (type === 'cmp') {
    return {
      id,
      type: 'companies',
      title: payload.title || payload.name || 'New Company',
      legal: payload.legal || {},
      shipping: payload.shipping || {},
      notes: payload.notes || '',
      created: nowISO,
      updated: nowISO
    };
  }
  if (type === 'cnt') {
    return {
      id,
      type: 'contacts',
      first_name: payload.first_name || payload.name || 'New',
      last_name: payload.last_name || payload.surname || 'Contact',
      value: payload.value || payload.email || payload.phone || '',
      contact_type: payload.contact_type || 'email',
      method: toArray(payload.method || []),
      tags: toArray(payload.tags || []),
      created_at: nowISO,
      updated_at: nowISO
    };
  }
  if (type === 'eml') {
    return {
      id,
      type: 'emails',
      title: payload.title || payload.subject || 'New email',
      from: payload.from || 'demo@assistant.local',
      to: toArray(payload.to || []),
      cc: toArray(payload.cc || []),
      bcc: toArray(payload.bcc || []),
      body: payload.body || payload.message || '',
      created: nowISO
    };
  }
  if (type === 'cll') {
    return {
      id,
      type: 'calls',
      title: payload.title || 'Call log',
      direction: payload.direction || 'outbound',
      call_start: payload.call_start || nowISO,
      call_end: payload.call_end || nowISO,
      duration: payload.duration || 0,
      caller_id: payload.caller_id || '',
      callee_id: payload.callee_id || ''
    };
  }
  if (type === 'evn') {
    return {
      id,
      type: 'events',
      title: payload.title || 'Event',
      start: payload.start || nowISO,
      end: payload.end || nowISO,
      participants: toArray(payload.participants || [])
    };
  }
  if (type === 'fls') {
    return {
      id,
      type: 'files',
      title: payload.title || payload.name || 'New file',
      format: payload.format || payload.mime || 'text/plain',
      link: payload.link || payload.url || '#',
      size: payload.size || 0,
      created_at: nowISO
    };
  }
  if (type === 'inv') {
    return {
      id,
      type: 'invoices',
      number: payload.number || id,
      title: payload.title || 'New invoice',
      issue_date: payload.issue_date || nowISO.slice(0, 10),
      due_date: payload.due_date || payload.end || nowISO.slice(0, 10),
      total: payload.total || 0,
      currency: payload.currency || 'EUR',
      status: payload.status || 'draft',
      cmp: toArray(payload.cmp || []),
      prj: toArray(payload.prj || [])
    };
  }
  return { id, type, title: payload.title || 'Item', created_at: nowISO };
}

function generateId(prefix = 'itm') {
  const random = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
  return `${prefix}-${Date.now()}-${random}`;
}

function toArray(value: any) {
  if (Array.isArray(value)) return value;
  if (value === undefined || value === null || value === '') return [];
  return [value];
}

function typePrefix(type: string) {
  const map: Record<string, string> = {
    tsk: 'tsk',
    cmp: 'cmp',
    cnt: 'cnt',
    eml: 'eml',
    cll: 'cll',
    evn: 'evn',
    fls: 'fls',
    inv: 'inv',
    wts: 'wts',
    tlg: 'tlg',
    sms: 'sms'
  };
  return map[type] || 'itm';
}

function findById(collection: string, id: string) {
  if (!DB[collection]) return null;
  return DB[collection].find((item: any) => item.id === id);
}

function translations() {
  return {
    en: {
      //Variables labels
      emails_label: '3 emails',
      calls_label: '2 calls',
      events_label: 'No events',
      chats_label: 'No chats',
      files_label: '7 uploaded',
      start_date_label: 'Start date',
      due_date_label: 'Due date',
      reminder_label: '1 notification',
      repeat_label: 'Repeat',
      assign_label: 'Marco Suriani',
      priority_label: 'Middle',
      private_label: 'Not private',
      share_label: '0 shares',
      time_spent_label: '1:15',
      start_timer_label: 'Start',
      invoices_label: '0 invoices',
      accepted_file_types: '.jpg, .jpeg, .png, .pdf, .doc, .docx, .mp4',
      file_max_size: 'Max file size: 10MB',
      reminder_recipient_option: 'All assigned people...',
      share_link: 'https://example.com/share-link',
      thanks_note_label:
        'Grazie per aver scelto i nostri servizi. Il pagamento è dovuto entro 30 giorni dalla data della fattura.',
      link_share_comment:
        'Sharing with a link will grant guests full access and privileges. If you prefer to assign different privileges, please use an email invitation. After regenerating the link, the previous link will no longer work.',

      // Wrong but required to be checked from priority
      None: 'None',
      Low: 'Low',
      Medium: 'Medium',
      High: 'High',
      Progressive: 'Progressive',

      // Special strings
      assigne_title: 'Assign Users to this Task',
      follow_title: 'Follow this Task',
      private_title: 'Set Privacy for this Task',
      previous_repeats_title: 'Previous Repeat Inputs',
      duration_placeholder: 'HH:MM',
      share_email_placeholder: 'Enter email addresses separated by commas',
      external_link_placeholder: 'https://example.com/link-to-file',
      file_description_placeholder: 'Add a description for this file',
      x_days_placeholder: 'e.g. 5',
      missing_fields_message: 'Please fill in all fields',
      x_days: 'How many days apart?',

      // Other actions and attributes
      actions: 'Actions',
      add_call: 'Add Call',
      add_comment: 'Add Comment',
      add_tags: 'Add Tags',
      add_time: 'Add Time',
      assign: 'Assign',
      assigned_to: 'Assigned to',
      assigned_user: 'Assigned User',
      assigned_users: 'Assigned Users',
      assign_user: 'Assign User',
      assign_users: 'Assign Users',
      assignment: 'Assignment',
      attach_file: 'Attach File',
      audio: 'Audio',
      audio_recording: 'Audio Recording',
      ban_user: 'Ban User',
      call: 'Call',
      call_log: 'Call Log',
      calls: 'Calls',
      call_type: 'Call Type',
      chat: 'Chat',
      chats: 'Chats',
      choose_file: 'Choose a File',
      clone: 'Clone',
      close: 'Close',
      comment: 'Comment',
      comments: 'Comments',
      copy: 'Copy',
      copy_link: 'Copy Link',
      date: 'Date',
      date_time: 'Date & Time',
      delete: 'Delete',
      delete_item: 'Delete Item (irreversible)',
      delete_user: 'Delete User',
      delete_with_project: 'Delete with Project',
      download: 'Download',
      due_date: 'Due Date',
      duration: 'Duration',
      email: 'Email',
      email_notification: 'Email Notification',
      emails: 'Emails',
      event: 'Event',
      events: 'Events',
      expire_in_30_days: 'Expire in 30 Days',
      external_link: 'External Link',
      file: 'File',
      file_description: 'File Description',
      files: 'Files',
      follow: 'Follow',
      follow_users: 'Follow Users',
      follower: 'Follower',
      followers: 'Followers',
      frequency: 'Frequency',
      high: 'High',
      hours: 'Hours',
      invoice: 'Invoice',
      invoices: 'Invoices',
      invite: 'Invite',
      ip_address: 'IP Address',
      last_access: 'Last Access',
      location: 'Location',
      log_more_file: 'Log More Files',
      low: 'Low',
      made: 'Made',
      made_call: 'Made Call',
      manage: 'Manage',
      message: 'Message',
      messages: 'Messages',
      method: 'Method',
      middle: 'Middle',
      minutes: 'Minutes',
      more: 'Show More',
      more_comment: 'Show More Comment',
      name: 'Name',
      new_call: 'New Call',
      new_chat: 'New Chat',
      new_email: 'New Email',
      new_event: 'New Event',
      new_file: 'New File',
      new_invoice: 'New Invoice',
      new_time_spent: 'New Time Spent',
      new_task: 'New Task',
      no: 'No',
      none: 'None',
      notify_users: 'Notify Users',
      optional: 'Optional',
      previous_calls: 'Previous Calls',
      previous_reminder: 'Previous Reminder',
      previous_reminders: 'Previous Reminders',
      previous_time_logs: 'Previous Time Logs',
      priority: 'Priority',
      priorities: 'Priorities',
      private: 'Private',
      privileges: 'Privileges',
      progressive: 'Progressive',
      push_notification: 'Push Notification',
      received: 'Received',
      received_call: 'Received Call',
      recipient: 'Recipient',
      recurrence: 'Recurrence',
      regenerate: 'Regenerate',
      regenerate_link: 'Regenerate Link',
      reminder: 'Reminder',
      reminder_date: 'Reminder Date',
      reminder_type: 'Reminder Type',
      repeat: 'Repeat',
      repeats_frequency: 'Repeat Frequency',
      same_day: 'Same Day',
      save: 'Save',
      select_date: 'Select Date',
      select_date_time: 'Select Date and Time',
      select_time: 'Select Time',
      send_invite: 'Send Invite',
      set_expiration_date: 'Set Expiration Date',
      set_priority: 'Set Priority',
      share: 'Share',
      show_more: 'Show More',
      sms_notification: 'SMS Notification',
      start_date: 'Start Date',
      start_timer: 'Start Timer',
      stop_timer: 'Stop Timer',
      summary: 'Summary',
      surname: 'Surname',
      tag: 'Tag',
      tags: 'Tags',
      time: 'Time',
      time_spent: 'Time Spent',
      upload_file: 'Upload File',
      user: 'User',
      user_summary: 'User Summary',
      visibility: 'Visibility',
      yes: 'Yes',

      sender: 'Sender',
      company_name: 'Company Name',
      address: 'Address',
      vat_number: 'VAT Number',
      recipient_code: 'Recipient Code',
      pec: 'PEC',
      phone: 'Phone',
      description: 'Description',
      quantity: 'Q.ty',
      unit_price: 'Price',
      total: 'Total',
      enter_description: 'Enter Description',
      add_row: 'Add Row',
      subtotal: 'Subtotal',
      vat: 'VAT',
      shipping: 'Shipping',
      rounding: 'Rounding',
      payment_methods: 'Payment Methods',
      account_holder: 'Account Holder',
      bank_transfer: 'Bank Transfer',
      notes: 'Notes',
      invoice_number: 'Invoice',
      bank_details: 'Bank Details',
      remove_row: 'Remove Row',
      send: 'Send',
      total_amount: 'Total Amount',
      number: 'No.',
      notes: 'Notes',

      outlook_email_view: 'Outlook - Vista Email Ricevute/Invitate',
      from: 'Da',
      to: 'A',
      you: 'te',
      hello: 'Ciao',
      reply: 'Rispondi',
      reply_all: 'Rispondi a tutti',
      forward: 'Inoltra',
      reply_function: 'Funzione Rispondi',
      reply_all_function: 'Funzione Rispondi a tutti',
      forward_function: 'Funzione Inoltra',
      search_email: 'Search Email',
      filter_sort: 'Filter and Sort',
      new_emails: 'New Email',
      email_section: 'Email Section',
      grid_view: 'Grid View',
      list_view: 'List View',
      properties: 'Properties',
      hide: 'Hide',
      hide_all: 'Hide All',

      send_email: 'Send Email',
      meeting: 'Meeting',
      edit: 'Edit',
      generete_task: 'Generete Task',
      info: 'Info',
      chronology: 'Chronology',
      add_tag: 'Add Tag',
      can_edit: 'Can Edit',
      can_comunicate: 'Can Comunicate',
      log: 'Log',
      hour: 'Hour',
      recived: 'Recived',
      add_task: 'Add Task',
      complete_all: 'Complete All',
      do_tomorrow: 'Do Tomorrow',
      reminder: 'Reminder',
      recurrency: 'Recurrency',
      scheduler: 'Scheduler',
      write_comment: 'Write a Comment',
      upload_audio: 'Upload Audio',
      insert_email_placeholder: 'Insert email separeted by comma',
      more_options: 'More Options',
      cc: 'CC',
      bcc: 'BCC',
      object: 'Object',
      insert_object: 'Insert an object',
      email_placeholder: 'Write your message...',
      include_previous_emails: 'Include Previous Emails',

      event_title: 'Event Title',
      insert_event_title: 'Insert Event Title',
      participants: 'Participants',
      insert_participants_emails: 'Insert Participants Emails',
      type_hash_for_suggestions: 'Type Hash For Suggestions',
      include_reminders: 'Include Reminders',
      reminder_time: 'Reminder Time',
      days: 'Days',
      weeks: 'Weeks',
      use_other_notification_methods: 'Use Other Notification Methods',
      add_reminder: 'Add Reminder',
      insert_event_location: 'Insert Event Location',
      repeat_event: 'Repeat Event',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      same_day_of_month: 'Same Day Of Month',
      same_day_of_year: 'Same Day Of Year',
      replace_audio: 'Replace Audio',
      before: 'Before',
      max_file_size: 'Max File Size',
      video_event: 'Video Event',
      add_repetition: 'Add Repetition',
      notify_partecipants: 'Notify Partecipants',
      all_day: 'All Day',
      end_date: 'End Date',
      required: 'Required',
      share_with_partecipant: 'Share With Partecipant',
      event_link: 'Event link',
      start_time: 'Start Time',
      hh: 'HH',
      mm: 'MM',
      date_placeholder: 'gg/mm/aaaa',
      frequecy: 'Frequency',
      total_items: 'Total items',
      todays_tasks: "Today's tasks",
      add_sub_tasks: 'Add Sub Tasks',
      sub_task_bulk_control: 'Sub Tasks Bulk Control',
      create_tasks: 'Create Tasks',
      reports_section: 'Reports section',
      item_control_section: 'Item Control Section',
      insert_text: 'Insert Text',
      date_format: 'dd/mm/yyyy',
      insert_link: 'Insert Link',
      insert_emails_separeted_by_comma: 'Insert Emails Separated by Comma',
      address_book: 'Address Book',
      decrease: 'Decrease',
      insert_number: 'Insert Number',
      increase: 'Increase',
      insert_comment: 'Insert Comment',
      new_tag: 'New TAG',
      genereted_link: 'Genereted Link',
      unread_messages: 'Unread Messages',
      todays_tasks: "Today's Tasks",
      homepage: 'Home Page',
      show_childrens: 'Show Childrens',
      task_completed: 'Task Completed'
    },
    it: {
      // Variables labels
      emails_label: '3 email',
      calls_label: '2 chiamate'
    }
  };
}
